import { Component } from '@angular/core';
import { ConfigService } from './services/config-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'OnDRM Console';

  constructor(
    private config: ConfigService
  ) { }

  ngOnInit(): void {
    //console.log(this.config.json);
  }
}
